import { JoinMeetingRequest, JoinMeetingResponse } from '@eigtech/meetings-types'
import { contextualPost, useMutation } from '@eigtech/ui-shared-api'
import { meetingsBasePath } from './constants'

const joinMeeting = async ({
  entityId,
  meetingId,
  ...body
}: Omit<JoinMeetingRequest, 'requestActor'>) =>
  contextualPost<JoinMeetingResponse>(
    `${meetingsBasePath}/meeting/join/${entityId}/${meetingId}`,
    body,
    { responseType: 'json' }
  )

export const useJoinMeeting = () =>
  useMutation({
    mutationFn: joinMeeting,
  })
